//copied from VPC
import { Formatters } from '@tableau/widgets/lib/gen-src/Localize';
import * as React from 'react';

import { DetailsTooltipStyles } from '../DetailsTooltipStyles';

export interface BasicFieldProps {
  name: string;
  value: number;
}

export function BasicField(props: BasicFieldProps) {
  return (
    <div className={DetailsTooltipStyles.MetadataSection}>
      <span>{props.name}</span>
      <span className={DetailsTooltipStyles.MetadataValue}>{Formatters.formatCount(props.value)}</span>
    </div>
  );
}
